
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/amanaki-boutique-saigon/stories/article/[slug]",
      function () {
        return require("private-next-pages/amanaki-boutique-saigon/stories/article/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/amanaki-boutique-saigon/stories/article/[slug]"])
      });
    }
  